<div class="loading-container" *ngIf="isLoading">
    <div class="loading-content">
        <mat-spinner diameter="40"></mat-spinner>
    </div>
</div>
<div class="cards-on-file" *ngIf="!isLoading">
    <h3>Pay with saved card:</h3>
    <form [formGroup]="form">
        <mat-radio-group class="cards" formControlName="cardOnFile">
            <mat-radio-button
                color="primary"
                class="example-radio-button"
                *ngFor="let card of cardsOnFile"
                value="{{ card.id }}"
                [disabled]="card.isExpired"
                qa="card-on-file"
            >
                <span> {{ card.cardType }} </span>
                <span> ****{{ card.displayNumber }}</span>
                <span
                    qa="card-expiration"
                    [ngClass]="{
                        'card-valid': !card.isExpired,
                        'card-expired': card.isExpired
                    }"
                >
                    {{ card.expirationStatus }}</span
                >
            </mat-radio-button>
        </mat-radio-group>

        <div class="add-new-card" qa="add-new-card" (click)="addCard()">
            <mat-icon>add </mat-icon>
            <span>Use New Card</span>
        </div>

        <mat-error *ngIf="cardOnFile?.touched && cardOnFile?.errors?.required">
            Please select a card on file or add a new card
        </mat-error>
    </form>

    <!-- Stripe Surcharge Banner -->
    <div
        *ngIf="shouldShowSurchargeBanner()"
        qa="stripe-surcharge-banner"
        style="margin-top: 16px; margin-bottom: 16px"
    >
        A <strong>{{ surchargeSettings.surchargeRate }}%</strong> surcharge will
        be added to the amount paid by the card once processed.
    </div>
</div>
